import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-offline',
  imports: [],
  templateUrl: './survey-offline.html',
  styleUrl: './survey-offline.css',
})
export class SurveyOffline {

}
